
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/terms",
      function () {
        return require("private-next-pages/en/legal/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/legal/terms"])
      });
    }
  